import { App } from 'antd'

/**
 * 重新导出一下，后续升级方便做兼容性处理
 */
export const useFeedback = App.useApp
